import * as React from 'react'
import Grid from '@mui/material/Grid'
import { Box } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useTheme } from '@mui/material/styles'

import AlleySpacer from 'components/Shared/AlleySpacer'
import ParticipantSummary from 'components/ParticipantProfile/ParticipantSummary'
import ParticipantTags from 'components/ParticipantProfile/ParticipantTags'
import ParticipantProfileTab from 'components/ParticipantProfile/ParticipantProfileTab'
import ShowParticipantNote from 'components/ParticipantProfile/AddNote/ShowParticipantNote'
import HelpText from 'components/ParticipantProfile/HelpText'
import ActionButtons from 'components/ParticipantProfile/ActionButtons'
import { ParticipantProfileContext } from 'containers/ParticipantProfile'
import CommonHeader from 'components/Shared/CommonHeader'
import { AdminUITheme } from 'types/AdminUiThemeMui'

const ParticipantProfile = () => {
  const { t } = useTranslation()
  const theme: AdminUITheme = useTheme()
  const { participantSummary, loading } = React.useContext(
    ParticipantProfileContext,
  ).state

  if (loading) return null

  return (
    <>
      <Box sx={theme.Participant.header}>
        <CommonHeader
          title={participantSummary?.login}
          subTitle={t('participant.headerDescription')}
          ActionButtons={[ActionButtons]}
          breadcrumb={[
            {
              icon: 'home',
              iconStyle: 'filled',
              link: '/adm',
            },
            {
              name: t('participant.heading'),
              link: '/adm/participants',
            },
          ]}
        />
      </Box>
      <AlleySpacer direction={'top'} spacing={3}>
        <ParticipantSummary />
        <Grid container spacing={2} pt={3}>
          <Grid item xs={12} md={8}>
            <ParticipantProfileTab />
          </Grid>
          <Grid item xs={12} md={4}>
            <ParticipantTags />
            <ShowParticipantNote adminType={participantSummary?.type} />
            <Box mt={4}>
              <HelpText />
            </Box>
          </Grid>
        </Grid>
      </AlleySpacer>
    </>
  )
}

export default ParticipantProfile
